import React from 'react'
import { MotionButton, MotionDiv, MotionImage, MotionSection } from '../motion/Motion'

export default function Homehero() {
  return (
    <MotionSection className="w-full py-0">
      <div className="w-full grid gap-10 lg:gap-y-0 lg:gap-x-0 lg:grid-cols-2 items-center py-12 sm:py-16 lg:py-0 lg:h-[520px]">
        {/* Left: Text content */}
        <MotionDiv className="space-y-6 px-4 sm:px-6 md:px-10 lg:pl-[4%] lg:pr-0 flex flex-col justify-center" delay={0.02}>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-display font-bold leading-tight text-gray-900">
            LOGO BRANDED
            <br />
            <span>
              <span className="text-pink-500">DOOR MATS</span> ZAMBIA
            </span>
          </h1>

          <p className="text-base sm:text-lg text-gray-700">
            Your favourite entrance upgrades, now beautifully priced.
          </p>

          <p className="text-[13px] text-gray-600 max-w-xl leading-relaxed">
            Your entrance is your most crucial marketing asset. Logo Branded Door Mats Zambia engineers superior,
            high-definition branded mats that not only dominate your first impression but also actively protect your
            flooring investment. Don't compromise with slow regional suppliers or local printers that fade in months.
            We provide fast, reliable, and premium matting solutions across Zambia.
          </p>

          <div className="flex flex-wrap items-center gap-4 pt-2">
            <button className="rounded-full bg-pink-500 px-6 py-2 text-sm font-semibold text-white shadow hover:bg-pink-600 transition-colors">
              <MotionButton>Contact Us</MotionButton>
            </button>
            <button 
              onClick={() => {
                const phoneNumber = '260981282836'
                const message = encodeURIComponent('Hello! I am interested in your door mats.')
                window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank')
              }}
              className="rounded-full bg-green-500 px-6 py-2 text-sm font-semibold text-white shadow hover:bg-green-600 transition-colors flex items-center gap-2"
            >
              <MotionButton>
                <span>WhatsApp Us</span>
              </MotionButton>
            </button>
          </div>
        </MotionDiv>

        {/* Right: Image - full height, no padding/rounding */}
        <MotionImage className="hidden sm:block relative w-full h-72 sm:h-96 lg:h-full overflow-hidden" delay={0.08} disableHover>
          <img
            src="/images/sectionimages/HOMEHERO.jpeg"
            alt="Logo Branded Door Mats Zambia entrance mat"
            className="w-full h-full object-cover"
          />
        </MotionImage>
      </div>
    </MotionSection>
  )
}
